<template>
    <div class="rent-switch">
        <span class="rent-switch-item" :class="{'rent-switch-on': checked}" @click="toggle"></span>
    </div>
</template>
<script>
export default {
    data () {
        return {
            checked: this.dValue
        }
    },
    props: {
        // value: Boolean,
        dValue: Boolean
    },
    watch: {
        checked: function (value) {
            this.$emit('input', value)
        },
        dValue: {
            handler: function (value) {
                // console.log(value)
                this.checked = value
            },
            immediate: true
        }
    },
    methods: {
        toggle: function () {
            this.checked = !this.checked
        }
    }
}
</script>
<style lang="scss">
    .rent-switch{
        .rent-switch-item {
            display: block;
            position: relative;
            width: 51px;
            height: 30px;
            outline: 0;
            border-radius: 16px;
            box-sizing: border-box;
            background-color: #e0dfde;
            transition: background-color 0.1s, border 0.1s;
            cursor: pointer;
        }
        .rent-switch-item:before {
            content: " ";
            position: absolute;
            top: 0;
            left: 0;
            width: 50px;
            height: 30px;
            border-radius: 15px;
            background-color: #e0dfde;
            transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
        }
        .rent-switch-item:after {
            content: " ";
            position: absolute;
            top: 2px;
            left: 3px;
            width: 26px;
            height: 26px;
            border-radius: 15px;
            background-color: #FFFFFF;
            box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.03), 0 1px 1px 0 rgba(0, 0, 0, 0.01), 0 3px 8px 0 rgba(0, 0, 0, 0.1);
            transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
        }
        .rent-switch-on {
            border-color: #ff9275;
            background-color: #ff9275;
        }
        .rent-switch-on:before {
            border-color: #ff9275;
            background-color: #ff9275;
        }
        .rent-switch-on:after {
            transform: translateX(20px);
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/widge/RentSwitch.vue